import { EditPage, EditPageTextField, EditPageCheckbox, EditPagePanel, EditPageTextArea } from './../../../common/EditPage';
import { update, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

const AiSpeechStylesEdit = () => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();
    const { speech_style_id } = useParams();

    useEffect(() => {
        getOne('/admin/ai/speech-styles/', speech_style_id).then(response => {
            setMetadata(response.data.metadata);
            setData(response.data.data);
        });
    }, []);

    const handleSave = () => {
        update('/admin/ai/speech-styles/', speech_style_id, {data: data}).then(response => {
            toast.success("Speech Style updated successfully", {});
            navigate('/ai/speech-styles');
        }).catch(error => {
            toast.error("Error updating Speech Style: " + error.message, {});
        });
    }

    const handleCancel = () => {
        navigate('/ai/speech-styles');
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }

    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage 
                handleSave={handleSave} 
                handleCancel={handleCancel} 
                title="Edit Speech Style"
                noDefaultButtons={!data.client_id}
            >
                <EditPagePanel className="col-lg-8">
                    <EditPageTextField 
                        label="Name" 
                        id="name" 
                        onChange={onChange} 
                        value={data.name} 
                        disabled={!data.client_id}
                    />
                    <EditPageTextArea 
                        label="Instructions" 
                        id="instructions" 
                        onChange={onChange} 
                        value={data.instructions} 
                        rows={40}
                        disabled={!data.client_id}
                    />
                </EditPagePanel>
            </EditPage>
        </div>
    );
};

export default AiSpeechStylesEdit;